import { render, staticRenderFns } from "./YourStoryAFF.vue?vue&type=template&id=b8378250"
import script from "./YourStoryAFF.vue?vue&type=script&lang=ts"
export * from "./YourStoryAFF.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports